import { render, staticRenderFns } from "./AreaInformation.vue?vue&type=template&id=41c2347c&scoped=true"
import script from "./AreaInformation.vue?vue&type=script&lang=js"
export * from "./AreaInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2347c",
  null
  
)

export default component.exports